import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formContainer: {
      maxWidth: "872px",
      margin: `${theme.spacing(8)} auto 0`,
      width: "100%",
      height: "100%",
    },
    sectionHeader: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
      textOverflow: "ellipsis",
      overflow: "hidden",
    },
    OLPaper: {
      marginBottom: theme.spacing(12),
      overflow: "hidden",
    },
    translationSection: {
      maxWidth: "100%",
      position: "relative",
      "&+&": {
        paddingTop: theme.spacing(12),
      },
      "&+&::after": {
        content: '""',
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
      },
    },
    conditionWrapper: {
      alignItems: "flex-start",
      display: "flex",
      justifyContent: "space-between",
    },
    clearIconWidth: {
      width: "36px",
      display: "flex",
      justifyContent: "end",
      marginTop: theme.spacing(8),
    },
    addTranslationBtn: {
      alignSelf: "start",
      color: theme.gray500,
      padding: theme.spacing(6, 6, 6, 0),
      margin: theme.spacing(6, 0),
      fontWeight: 500,
    },
    tabs: {
      display: "flex",
      justifyContent: "space-between",
      gap: theme.spacing(8),
      position: "relative",
      alignItems: "center",
    },
    benefitsContainer: {
      display: "flex",
      marginBottom: theme.spacing(12),
    },
    fullWidth: {
      width: "100% !important",
      maxWidth: "100% !important",
    },
    zeroPadding: {
      padding: "0 !important",
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(5),
      "& + &": {
        marginTop: 0,
      },
    },

    translationContainer: {
      marginTop: theme.spacing(12),
    },
    itemWrapper: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      overflow: "hidden",
      textOverflow: "ellipsis",

      "& span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    closeIcon: {
      width: "18px",
      height: "18px",
      marginLeft: theme.spacing(5),
    },
    addTier: {
      flexShrink: 0,
    },
    conditionsHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: theme.spacing(8),
    },
    expandIcon: {
      color: theme.primary500,
    },
    expandedView: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      zIndex: 9999,
      borderRadius: 0,
      padding: theme.spacing(12, 30),
      overflow: "auto",
    },
    closeIconWrapper: {
      backgroundColor: "#F0F0F0",
      width: "28px",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      cursor: "pointer",

      "& svg": {
        color: "#9B9B9B",
      },
    },
    title: {
      fontSize: "16px",
      fontWeight: 500,
      marginBottom: theme.spacing(8),
    },
    warnIcon: {
      color: theme.red500,
      width: "15px",
      height: "15px",
      marginRight: theme.spacing(4),
    },
    modalDescription: {
      color: theme.gray500,
      margin: 0,
      fontSize: 14,
      marginTop: theme.spacing(-8),
    },
    form: {
      paddingBottom: theme.spacing(12),
    },
    errorGeneral: {
      fontSize: "12px",
      color: theme.red500,
      marginTop: theme.spacing(-12),
      marginBottom: theme.spacing(12),
    },
    isActive: {
      marginBottom: theme.spacing(12),
    },
    warning: {
      color: theme.red500,
      fontWeight: 400,
      fontSize: 14,
      marginBottom: theme.spacing(12),
    },
    wrapper: {
      overflow: "auto",
    },
    inputWrapper: {
      flexWrap: "nowrap",
    },
  }),
);
